/**
 * Helpers para mapear modelos del backend a la forma que esperan los
 * componentes de presentación del Dashboard del vecino (Sprint 12
 * S12-09). Centraliza el formato meta/time + el mapeo tipo→iconVariant
 * para que VecinoHome.tsx, /vecino/documentos y /vecino/avisos los
 * compartan.
 */
import type { AvisoRead, DocumentoRead, TipoDocumento } from './api/types';
import type { DocumentoIconVariant } from '../data/doc-icons';

// Mapping tipo de documento -> variante de icono.
const ICON_POR_TIPO: Record<TipoDocumento, DocumentoIconVariant> = {
  reglamento: 'success',
  acta: 'info',
  informe: 'neutral',
  otro: 'danger',
};

export function iconVariantPorTipo(tipo: TipoDocumento): DocumentoIconVariant {
  return ICON_POR_TIPO[tipo] ?? 'neutral';
}

const MESES_CORTOS = [
  'ene', 'feb', 'mar', 'abr', 'may', 'jun',
  'jul', 'ago', 'sep', 'oct', 'nov', 'dic',
];

function fechaCortaEs(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  const [, anio, mm, dd] = m;
  const idx = parseInt(mm, 10) - 1;
  return `${parseInt(dd, 10)} ${MESES_CORTOS[idx] ?? mm} ${anio}`;
}

function fechaRelativaCorta(iso: string): string {
  const ahora = new Date();
  const fecha = new Date(iso);
  if (Number.isNaN(fecha.getTime())) return iso;
  const diffMs = ahora.getTime() - fecha.getTime();
  const diffDias = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (diffDias === 0) return 'Hoy';
  if (diffDias === 1) return 'Ayer';
  if (diffDias < 7) return `Hace ${diffDias} días`;
  return fechaCortaEs(iso);
}

const ETIQUETA_TIPO_DOC: Record<TipoDocumento, string> = {
  reglamento: 'Reglamento',
  acta: 'Acta',
  informe: 'Informe',
  otro: 'Documento',
};

export function metaDocumento(doc: DocumentoRead): string {
  return `${ETIQUETA_TIPO_DOC[doc.tipo] ?? 'Documento'} · publicado ${fechaCortaEs(doc.publicado_at)}`;
}

export function timeAviso(aviso: AvisoRead): string {
  return fechaRelativaCorta(aviso.publicado_at);
}
